import React from 'react'
import { Link } from "react-router-dom";
import Header from '../components/Header';
import Footer from '../components/Footer';
import "./AllPartners.css"; 
import LabCard from "../components/LabCard"; 

import blallogo from "../assets/images/blallogo.png";
import pathlablogo from "../assets/images/pathlablogo.png";
import carelogo from "../assets/images/carelogo.png";
import goyallogo from "../assets/images/goyallogo.png";
import PRECISIONlogo from "../assets/images/PRECISION-logo.png"
import AppShowcase from '../layout/Home/AppShowcase';
import Blog from '../layout/Home/Blog';
import Faq from '../layout/Home/Faq';

export const labs = [
  {
    id: 1,
    name: "Dr. B. Lal",
    logo: blallogo,
    bgColor: "#E8F5EC",
     link: "/drblal",
  },
  {
    id: 2,
    name: "Dr. Lal PathLabs",
    logo: pathlablogo,
    bgColor: "#FFF0C9",
    link: "/drlalapath",
  },
  {
    id: 3,
    name: "CaresAtHome",
    logo: carelogo,
    bgColor: "#1294892e",
    link: "/labtest",
  },
  {
    id: 4,
    name: "Dr. Goyal's",
    logo: goyallogo,
    bgColor: "#FFE3E3",
    link: "/drblal",
  },
   {
    id: 5,
    name: "PRECISION PATH LAB",
    logo: PRECISIONlogo,
    bgColor: "#D2F2FF",
    link: "/drblal",
  },
];

export default function AllPartners() {
  return (
    <>
    <Header/>
          
    <div className="test_bredcum_sec with_background">
       <div className="container-fluid">
          <div className="test_bredcum">
            <Link to="/">Home</Link>
            <span>&gt;</span>
            <span className='name_p'>All Partners</span>
          </div> 
        </div> 
    </div>

    <div className="all_partners_main">
      <div className="container-fluid">
        <div className="all_partners_main_inner">
           <div className="row">
            {labs.map((lab) => (
              <div className="col-lg-4 col-md-6 col-12 mb-4" key={lab.id}>
                <LabCard lab={lab} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    
    <div className="cta_ap">
      <AppShowcase />
    </div> 
 
    

    <Footer/>
    </>
  )
}
